// import React from "react";
import React, { Component } from 'react';

import Result from '../../Components/Result/';
import SearchBar from '../../Components/SearchBar/';
import '../../App.css';


export default class HomeScreen extends Component {

    constructor(props) {
        super(props);
        this.state = {
          data: null,
          result: true,
          error: null,
          actualS: null,
          actualL: null
        }
    }

    static defaultProps = {
      datas: [],
    };

    componentDidMount() {
      window.scrollTo(0, 0)
    }

    componentWillMount(){
      localStorage.removeItem('service');
    }



    updateActual = (data,type) => {
    // console.log(data,type);

    

      if(type === "reset"){
        this.setState({ actualS: data , actualL: data, result: true }, () => {
          this.setState({ actualS: data , actualL: data, result: true });
        });
      }

      if(type === "result"){
        this.setState({result: data });
      }

      if(type === "letter"){
        // console.log(data,type);
      this.setState({actualL: data });}

      if(type === "service"){

        // console.log(data,type);
        
      this.setState({actualS: data });}

      // Partie de code commentée qui semble permettre d'utiliser le filtre par lettres
      // couplé à la recherche textuelle MAIS le filtre par lettres est grisé lors
      // qu'on saisi une recherche textuelle. Les deux ne peuvent donc pas être couplés

      // if((this.state.actualL && this.state.actualS) && (this.state.actualL.length >= 1 && this.state.actualS.length >= 1)){

      //   var vTab = this.state.actualS;
      //   for (const [key, value] of Object.entries(vTab)){
      //       if(!this.state.actualL.includes(value.substr(0, 1))){
      //         vTab.splice(value, 1);
      //       }
      //     }
      //     console.log(vTab);
      //     this.setState({actualS: vTab });
      // }


    };


  render() {
//
    // console.log('HomeScreen this.state : ',this.state);
    // console.log('HomeScreen this.props : ',this.props);

    // console.log('service localStorage : ',JSON.parse(localStorage.getItem('service')));

    const allDatas = this.props.datas
      ? this.props.datas
      : null;


      if (!allDatas) {
        return (
          <div className="App">
            <p></p>
          </div>
        );
      }

    return (

      <div >
        <SearchBar datas={allDatas} setUpdate={this.updateActual}/>
        <Result datas={allDatas} ifService={this.state.actualS} ifLetter={this.state.actualL} isResult={this.state.result}/>
      </div>


    );
  }
}
